import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

// Replaces turbo_stream_from for comments pages.
//
// turbo_stream_from / TurboCableStreamSourceElement has an unreliable
// subscription lifecycle on web (but not on native), causing real-time comment
// broadcasts to be missed. This controller uses the same direct ActionCable
// subscription pattern as discovery_controller.js (known to work on both
// platforms) and pipes received HTML through Turbo.renderStreamMessage.
//
// Usage: add data-controller="comments-cable"
//        and data-comments-cable-signed-stream-value="SIGNED_NAME" to
//        the page wrapper.  The signed stream name is computed server-side
//        via Turbo::StreamsChannel.signed_stream_name([stream_string]).
export default class extends Controller {
  static values = { signedStream: String }

  connect() {
    if (!this.signedStreamValue) return

    this._consumer = createConsumer()
    this._subscription = this._consumer.subscriptions.create(
      { channel: "Turbo::StreamsChannel", signed_stream_name: this.signedStreamValue },
      { received: (data) => this._received(data) }
    )
  }

  disconnect() {
    this._subscription?.unsubscribe()
    this._consumer?.disconnect()
  }

  _received(data) {
    if (typeof data === "string" && window.Turbo) {
      window.Turbo.renderStreamMessage(data)
    }
  }
}
